// extracted by mini-css-extract-plugin
export default {"day-note__title":"day-note__title--r5LFl","dayNoteTitle":"day-note__title--r5LFl","day-note":"day-note--mhnEB","dayNote":"day-note--mhnEB"};